import * as styles from "./ScrollArea.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { ScrollArea as BaseScrollArea } from "@base-ui/react/scroll-area";

import type { ScrollAreaProps } from "./ScrollArea.types";

export function ScrollArea({
  className,
  ...props
}: ScrollAreaProps): JSX.Element {
  return (
    <BaseScrollArea.Root
      data-slot="scroll-area"
      className={clsx(styles.root, className)}
      {...props}
    />
  );
}
